import React from 'react';
import { isEqual } from 'lodash';
import { Route } from '@reverbdotcom/commons/src/route_settings';
import { CollectionHeaderActions, CollectionHeaderStore } from '../components/discovery/stores/collection_header_store';
import connectRouterChange from '../components/shared/connect_router_change';
import { SALE_ROUTE_PATH } from '../components/shared/constants';

function onLoad(props) {
  const { params } = props;
  const storeParams = CollectionHeaderStore.getState().params;

  if (isEqual(params, storeParams)) { return; }

  CollectionHeaderActions.fetchOrClear(params);
}

const SaleRoute = (
  <Route
    key={SALE_ROUTE_PATH}
    path={SALE_ROUTE_PATH}
    props={{
      clientSide: true,
    }}
    getComponent={(_location, cb) => {
      import(
        /* webpackChunkName: 'marketplace' */
        '../components/discovery/sales/sale_grid'
      ).then((m) => {
        const SaleGrid = m.default;
        const connected = connectRouterChange(onLoad)(SaleGrid, 'SaleGrid');
        cb(null, connected);
      });
    }}
  />
);

export default SaleRoute;
